import React from 'react';
import Purchases from './Purchases';

function AddPurchase() {
  return <Purchases initialViewMode="add" />;
}

export default AddPurchase;



